import {SelectedItemsData} from "./EntitySelector.types";

export const ENTITY_TYPES = {
  ACHIEVEMENT: 'achievement',
  ARTICLE: 'article',
  COLLECTION: 'collection',
  EVENT: 'event',
  EXHIBIT: 'exhibit',
  FACILITY: 'facility',
  PLACE: 'place',
  SITE: 'site',
  TRAIL: 'trail',
  QUIZ: 'quiz',
  ZONE: 'zone',
} as const;

export const defaultSelectedItems: SelectedItemsData = {
  achievement: [],
  article: [],
  collection: [],
  event: [],
  exhibit: [],
  facility: [],
  place: [],
  quiz: [],
  site: [],
  trail: [],
  zone: [],
}